import baseDataService from 'src/services/baseDataService';
import phoneTypesService from '../services/phoneTypesService';
import addressTypesService from '../services/addressTypesService';
import RESTAddressTypesService from '../services/RESTAddressTypesService';
import contactMethodsService from '../services/contactMethodsService';
import dispatchWorkflowService from '../services/dispatchWorkflowService';
import dispatchStatusesService from '../services/dispatchStatusesService';
import dispatchStatesService from '../services/dispatchStatesService';
import dispatchContactTypesService from '../services/dispatchContactTypesService';
import benefitService from '../services/benefitService';

const restAddressTypesService = new RESTAddressTypesService();

export const GET_PHONE_TYPES = '@types/get-phone-types';
export const GET_CLIENT_PHONE_TYPES = '@types/get-client-phone-types';
export const GET_DISPATCH_STATUSES_TYPES = '@types/get-dispatch-statuses-types';
export const GET_DISPATCH_WORKFLOW_TYPES = '@types/get-dispatch-workflow-types';
export const GET_DISPATCH_STATES_TYPES = '@types/get-dispatch-states-types';
export const GET_DISPATCH_CONTACT_TYPES = '@types/get-dispatch-contact-types';
export const GET_WORKFLOW_COMPONENTS = '@types/get-workflow-components';
export const GET_ADDRESS_TYPES = '@types/get-address-types';
export const GET_CLIENT_ADDRESS_TYPES = '@types/get-client-address-types';
export const GET_BENEFIT_CATEGORIES = '@types/get-benefit-categories';
export const GET_BENEFIT_TYPES = '@types/get-benefit-types';
export const GET_CONTACT_METHODS = '@types/get-contact-methods';
export const GET_CLIENT_CONTACT_METHODS = '@types/get-client-contact-methods';
export const GET_USER_ROLES = '@types/get-user-roles';
export const GET_BASE_DATA = '@types/get-base-data';

export function getBaseData() {
  const request = baseDataService.getBaseData();

  return (dispatch) => {
    request.then((response) => {
      dispatch({
        type: GET_BASE_DATA,
        payload: response
      });
    });
  };
}

export function getPhoneTypes() {
  const request = phoneTypesService.getPhoneTypes();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_PHONE_TYPES,
      payload: response
    }));
  };
}

export function getClientPhoneTypes() {
  const request = phoneTypesService.getClientPhoneTypes();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_CLIENT_PHONE_TYPES,
      payload: response
    }));
  };
}

export function getDispatchStatusesTypes() {
  const request = dispatchStatusesService.getDispatchStatuses();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_DISPATCH_STATUSES_TYPES,
      payload: response
    }));
  };
}

export function getDispatchWorkflowTypes() {
  const request = dispatchWorkflowService.getDispatchWorkflowTypes();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_DISPATCH_WORKFLOW_TYPES,
      payload: response
    }));
  };
}

export function getDispatchStatesTypes() {
  const request = dispatchStatesService.getDispatchStates();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_DISPATCH_STATES_TYPES,
      payload: response
    }));
  };
}

export function getDispatchContactTypes() {
  const request = dispatchContactTypesService.getContactTypes();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_DISPATCH_CONTACT_TYPES,
      payload: response
    }));
  };
}

export function getDispatchWorkflowComponents() {
  const request = dispatchWorkflowService.getDispatchWorkflowComponents();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_WORKFLOW_COMPONENTS,
      payload: response
    }));
  };
}

export function getAddressTypes() {
  const request = restAddressTypesService.getAddressTypes();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_ADDRESS_TYPES,
      payload: response
    }));
  };
}

export function getClientAddressTypes() {
  const request = addressTypesService.getClientAddressTypes();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_CLIENT_ADDRESS_TYPES,
      payload: response
    }));
  };
}

export function getContactMethods() {
  const request = contactMethodsService.getContactMethods();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_CONTACT_METHODS,
      payload: response
    }));
  };
}

export function getClientContactMethods() {
  const request = contactMethodsService.getClientContactMethods();

  return (dispatch) => {
    request.then((response) => {
      dispatch({
        type: GET_CLIENT_CONTACT_METHODS,
        payload: response
      });
    });
  };
}

export function getBenefitCategories() {
  const request = benefitService.getBenefitCategories();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_BENEFIT_CATEGORIES,
      payload: response
    }));
  };
}

export function getBenefitTypes() {
  const request = benefitService.getBenefitTypes();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_BENEFIT_TYPES,
      payload: response
    }));
  };
}
